<template>
  <div class="tabs-head">
    <label v-for="({ name, value }) in formatedTabs"
      class="tab"
      :class="{ active: active === value }"
      :key="value"
      @click="$emit('update:active', value)">
      {{ name }}
    </label>
  </div>
</template>

<script>
export default {
  props: ['active', 'tabs'],
  computed: {
    formatedTabs() {
      if (typeof this.tabs[0] === 'object') return this.tabs

      return this.tabs.map(name => ({ name, value: name }))
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.tab {
  border-bottom: 2px solid transparent;
  color: $c-text-light;
  cursor: pointer;
  display: inline-block;
  font-weight: $semibold;
  line-height: $lh * 1.5;
  margin: 0;
  padding: 0 1rem;
  &:hover {
    color: $c-main;
  }
  &.active {
    color: $c-text-black;
    border-color: $c-main;
  }
}

@media screen and (max-width: ($res-xs - 1px)) {
  .tab {
    padding: 0 0.25rem;
  }
}

.tabs {
  &.active {
    .tabs-head {
      border-bottom: 1px solid $c-border;
      margin-bottom: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/TabsHead.vue